import type { AxiosError } from 'axios';
import { createQuery } from 'react-query-kit';

import { client } from '@/api/common';

export enum FilterName {
  STATUS = 'status',
  LOCATION = 'location',
}

export type Filter = {
  name: FilterName;
  options: any[];
  collapsed: boolean;
  selected: number | number[];
};

type Variables = {
  text?: string;
};
type Response = Filter[];

const fetchReservationFilters = async (
  variables: Variables
): Promise<Response> => {
  const response = await client.get(
    'v2/internal/partners/reservations/filters',
    {
      params: { text: variables?.text || '' },
    }
  );

  const formattedData = response.data.data.map((filter: Filter) => {
    return {
      ...filter,
      selected: [],
    };
  });

  return [...formattedData];
};

export const useReservationFilters = createQuery<
  Response,
  Variables,
  AxiosError
>({
  queryKey: ['reservation/filters'],
  fetcher: fetchReservationFilters,
});
